import { withKey, withoutKey, type GlobalStateContext } from 'piral-core'
import type { TrayRegistration } from './TrayApi'

export function registerTrayItem(ctx: GlobalStateContext, name: string, value: TrayRegistration) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      trayItems: withKey(state.registry.trayItems, name, value)
    }
  }))
}

export function unregisterTrayItem(ctx: GlobalStateContext, name: string) {
  ctx.dispatch((state) => ({
    ...state,
    registry: {
      ...state.registry,
      trayItems: withoutKey(state.registry.trayItems, name)
    }
  }))
}
